module.exports = __webpack_public_path__ + "static/qr-2876a4e928717e07fd8c5e26c72e510a.webp";